// extracted by mini-css-extract-plugin
module.exports = {"container":"ContainerLong_container__s3Iwx","content":"ContainerLong_content__Quw_q"};